module.exports = __webpack_public_path__ + "media/Loops Keys.ec3dda95.wav";